import { allMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

const reasonMap: Record<string, string> = {
  'shi-wei': '节奏温和、没有强冲突，适合想安静看完一部的夜晚。',
  'wu-gang': '悬疑铺陈扎实，线索与情感双线并行，适合喜欢推理的人。',
  'jiu-cheng': '细节扎实、情绪克制，老街与照相馆的意象很耐看。',
  'guang-nian': '把科幻设定落回情感，时间差带来的遗憾感是最大看点。',
  'chang-feng': '场面开阔、叙事从容，适合在影院大银幕观看。',
  'chun-shan': '台词细腻、氛围舒服，看完会想给久未联系的人发条消息。',
};

const highRated = allMovies.filter((movie) => movie.score >= 8.3).sort((a, b) => b.score - a.score);

export default function HighRated() {
  return (
    <section id="highrated" className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="高分推荐"
          title="高分推荐：评分靠前，附一句推荐理由"
          desc="如果热播榜回答的是“大家都在看什么”，高分推荐回答的是“看完大概率不亏”。下面作品评分靠前，每部附一句推荐理由，帮你在一分钟内做决定。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {highRated.map((movie) => (
            <article
              key={movie.id}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 hover:bg-secondary-50"
            >
              <div className="h-32 w-[88px] shrink-0 overflow-hidden rounded-md">
                <img src={movie.poster} alt={`${movie.title} 海报`} className="h-32 w-full object-cover object-top" />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{movie.title}</h3>
                  <span className="flex h-9 w-9 shrink-0 flex-col items-center justify-center rounded-full bg-accent-500 text-accent-950">
                    <span className="font-heading text-sm font-bold leading-none">{movie.score.toFixed(1)}</span>
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-600">
                  {movie.year} · {movie.region} · {movie.runtime}
                </p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {movie.genres.map((genre) => (
                    <span key={genre} className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
                      {genre}
                    </span>
                  ))}
                </div>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                  {reasonMap[movie.id] ?? movie.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}